import * as RootActions from '../actions/index';
import { reducer } from './reducerUtils';

const initialState = {
  isOfficeInitialized: false,
  alertText: '',
  initializationError: false,
  alertStatus: '',
  isLoading: false,
  isSyncingAttachments: false,
  itemType: '',
  isEmail: false,
  isCalendar: false,
};

export default reducer({
  [RootActions.OFFICE_INITIALIZED]: (state) => ({
    ...state,
    isOfficeInitialized: true,
  }),
  [RootActions.OFFICE_UNINITIALIZED]: (state) => ({
    ...state,
    isOfficeInitialized: false,
  }),
  [RootActions.CLEAR_ALERT_TEXT]: (state) => ({
    ...state,
    alertText: '',
    alertStatus: '',
  }),
  [RootActions.EMAIL_SELECTED]: (state) => ({
    ...state,
    itemType: 'message',
    isEmail: true,
  }),
  [RootActions.CALENDAR_SELECTED]: (state) => ({
    ...state,
    itemType: 'appointment',
    isCalendar: true,
  }),
  [RootActions.CHANGE_ALERT_TEXT]: (state, action) => ({
    ...state,
    alertText: action.payload.text,
    alertStatus: action.payload.status,
  }),
  [RootActions.SET_INITIALIZATION_ERROR]: (state, action) => ({
    ...state,
    initializationError: action.status,
  }),
  [RootActions.IS_LOADING]: (state, action) => ({
    ...state,
    isLoading: action.payload,
  }),
  [RootActions.IS_SYNCING_ATTACHMENTS]: (state, action) => ({
    ...state,
    isSyncingAttachments: action.payload,
  }),
}, initialState);
